import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const ImportantNotice = ({ message, backgroundColor, color, iconColor, iconName, textColor }) => {
    return (
        <React.Fragment>
            <div className="d-flex " style={{ backgroundColor: backgroundColor, borderLeft: `2px solid ${color}`, borderRadius: 8, padding: 20, marginTop: 10 }}>
                <div style={{ marginRight: 15 }}>
                    <div className="important-icon-container">
                        <Icon icon={iconName || "ri:information-line"} className="font-size-20" style={{ color: iconColor || color, width: 16, height: 16 }} />
                    </div>
                </div>
                <div style={{ fontFamily: 'FunnelSans', fontSize: 14, color: textColor || "#282828", fontWeight: 400 }}>{message}</div>
            </div>
        </React.Fragment>
    );
};

export default ImportantNotice;